module.exports = __webpack_public_path__ + "static/media/phone.b471b73b.svg";